import React from 'react'
import $t from '../../../../../i18n'

export const ProviderDetailsLanguages = ({ languages }) => {
  return (
    <div className='provider-details'>
      <div className='provider-desc semi-bold'>
        {$t('providerPage.providerDetails.languages')}
      </div>
      <div className='provider-desc'>
        {languages?.map(language => language?.name)?.join(', ') ||
          $t('providerPage.dataNotAvailable')}
      </div>
    </div>
  )
}

export default ProviderDetailsLanguages
